import { create, test, enforce } from 'vest';
import { ContentEntity } from './types';


function hasDuplicatePerson(arr) {
  const seenIds = new Set();
  for (const obj of arr) {
    if (seenIds.has(obj.vtr_id)) {
      return true; // Found a duplicate ID
    }
    seenIds.add(obj.vtr_id);
  }
  return false; // No duplicate IDs found
}

export const C3ValidationSuite = create((data: any) => {
  test('associated_person', 'Person is required', () => {
    enforce(data.associated_person).isNotEmpty();
    enforce(data.associated_person[0].vtr_id).isTruthy();
  });
   test('Mandatory', 'At least one Content is required.', () => {
      const content_data_array = (data.contents as Array<Partial<ContentEntity>>)
        .filter(x => x)
        .map(x => (x.vtr_id ?? ''))
        .filter(x => x !== '');
        
      enforce( data.contents && content_data_array?.length > 0).isTruthy();
    });

    test('Mandatory', 'Invalid Content added', () => {
      const content_data_array = (data.contents as Array<Partial<ContentEntity>>);
      enforce( data.contents && !content_data_array?.some((obj) => obj?.vtr_id === '')).isTruthy();
    });
test('Mandatory','Role must exist for all contents', () => {
  const contents = data.contents as Array<Partial<ContentEntity>>;

  enforce(
    contents.every(
      (item) => typeof item.role === 'string' && item.role.trim() !== ''
    )
  ).isTruthy();
});
    test('Mandatory', 'Duplicate Content Added', () => {
      const content_data_array = (data.contents as Array<Partial<ContentEntity>>);
      enforce( data.contents && !hasDuplicatePerson(content_data_array)).isTruthy();
    });

    test('Mandatory', 'Maximum 25 Content can be associated at a time.', () => {
      const content_data_array = (data.contents as Array<Partial<ContentEntity>>)
        .filter(x => x)
        .map(x => (x.vtr_id ?? ''))
        .filter(x => x !== '');
      enforce(content_data_array?.length <= 25).isTruthy();
    });
  test('source', 'Source is required', () => {
    enforce(data.source).isNotEmpty();
  });
/* 
  test('ingestion_method', 'Ingestion method is required', () => {
    enforce(data.ingestion_method).isNotEmpty();
  }); */
}); 